<script setup lang="ts">
  defineProps({
    category: { type: Object, required: true },
  });
</script>
<template>
  <article class="category-card">
    <SfTile :href="category.url" class="category-card__link" small interactive>
      <div class="category-card__photo">
        <MediaPicture :photo="category.photo" sizes="560x390 2x, 260x195" />
      </div>
      <h2 class="category-card__heading">
        {{ category.name }}
      </h2>
      <span class="category-card__count" :aria-label="$t('Ilośc produktów')">
        ({{ category.products }})
      </span>
    </SfTile>
  </article>
</template>
<style scoped lang="scss">
  .category-card {
    display: flex;
    --sf-tile-interactive-box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.1);

    &__heading {
      font-size: 1rem;
    }

    &__link {
      flex-grow: 1;
      text-align: center;
      justify-content: center;
    }

    &__count {
      align-items: center;
      color: var(--color-dark-gray);
      font-size: 0.875rem;
    }

    :deep(.tile__content) {
      flex-grow: 0;
    }
  }

  @media(max-width: 992px) {
    .category-card {
      --sf-tile-small-gap: 0.5rem;
    }
  }
</style>
